module.exports = __webpack_public_path__ + "img/lang-tr.a6e7c087.svg";